import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bottombarSearch: {
    show: false,
    placeholder: '',
  },
};
const bottombarSlice = createSlice({
  name: 'bottombarSlice',
  initialState,
  reducers: {
    setButtombarContent: (state, action) => {
      const { bottombarSearch } = action?.payload;
      state.bottombarSearch = bottombarSearch;
    },
  },
});

export const { setButtombarContent } = bottombarSlice.actions;
export default bottombarSlice.reducer;
